/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1MinusIcon32Regular = forwardRef('People1MinusIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z" }),
        React.createElement("path", { d: "M6.102 24.975C5.44 25.816 5 26.943 5 28.5a1 1 0 1 1-2 0c0-1.966.566-3.539 1.532-4.764.955-1.211 2.25-2.017 3.612-2.558C10.84 20.108 14.009 20 16 20a1 1 0 1 1 0 2c-1.975 0-4.806.119-7.118 1.037-1.143.454-2.105 1.082-2.78 1.938Z" }),
        React.createElement("path", { d: "M20 25a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H20Z" })));
});
